
import Vue from 'vue';
// Create an event Vue instance
export const EventBus = new Vue();
